export default __webpack_public_path__ + "src/assets/icn-back-arrow.c774bf6fe6a507a17c15ee72c0c03f1a.svg";